export const URGENT_ALERTS = [
  {
    id: 'UA-001',
    severity: 'critical',
    message: 'Truck AU-402 waiting at border clearance for 3 hours',
    action: 'Escalate customs',
    tripId: 'TRP-24018',
  },
  {
    id: 'UA-002',
    severity: 'critical',
    message: 'Driver Farhan requires immediate document approval',
    action: 'Approve docs',
    tripId: 'TRP-24021',
  },
  {
    id: 'UA-003',
    severity: 'warning',
    message: 'TRP-24015 — Bitumen load temperature rising above threshold',
    action: 'Contact driver',
    tripId: 'TRP-24015',
  },
  {
    id: 'UA-004',
    severity: 'warning',
    message: 'E11 congestion — 4 active trips affected near Al Dhaid interchange',
    action: 'Review routes',
    tripId: null,
  },
];

export const ACTIVE_TRIPS = [
  {
    id: 'TRP-24011',
    vehicle: 'DXB-T-4021',
    driver: 'Ahmed Al Mansouri',
    route: 'Jebel Ali → Fujairah',
    product: 'Diesel ULSD',
    eta: '14:35 GST',
    delayStatus: 'normal',
    progress: 72,
  },
  {
    id: 'TRP-24012',
    vehicle: 'AUH-T-1188',
    driver: 'Rajesh Kumar',
    route: 'Ruwais → Musaffah',
    product: 'Bitumen 80/100',
    eta: '16:10 GST',
    delayStatus: 'delayed',
    progress: 41,
  },
  {
    id: 'TRP-24013',
    vehicle: 'SHJ-T-3305',
    driver: 'Mohammed Hassan',
    route: 'Hamriyah → Jebel Ali',
    product: 'Jet A-1',
    eta: '13:50 GST',
    delayStatus: 'normal',
    progress: 88,
  },
  {
    id: 'TRP-24014',
    vehicle: 'FJR-T-0092',
    driver: 'Sanjay Patel',
    route: 'Fujairah → Dubai Silicon Oasis',
    product: 'Gasoil 10ppm',
    eta: '15:20 GST',
    delayStatus: 'normal',
    progress: 55,
  },
  {
    id: 'TRP-24015',
    vehicle: 'DXB-T-5510',
    driver: 'Khalid Omar',
    route: 'Jebel Ali → Al Ain',
    product: 'Bitumen 60/70',
    eta: '17:45 GST',
    delayStatus: 'delayed',
    progress: 28,
  },
  {
    id: 'TRP-24016',
    vehicle: 'AUH-T-2244',
    driver: 'Imran Siddiqui',
    route: 'Ruwais → Khalifa Port',
    product: 'Crude Oil (Murban)',
    eta: '18:00 GST',
    delayStatus: 'normal',
    progress: 19,
  },
  {
    id: 'TRP-24017',
    vehicle: 'DXB-T-7781',
    driver: 'Yusuf Ibrahim',
    route: 'Musaffah → Sharjah Industrial',
    product: 'Diesel ULSD',
    eta: '14:05 GST',
    delayStatus: 'normal',
    progress: 94,
  },
  {
    id: 'TRP-24018',
    vehicle: 'AU-402',
    driver: 'Farhan Malik',
    route: 'Hatta → Oman Border (Al Ain)',
    product: 'LPG Mix',
    eta: 'Delayed',
    delayStatus: 'delayed',
    progress: 62,
  },
  {
    id: 'TRP-24019',
    vehicle: 'FJR-T-0144',
    driver: 'Anil Sharma',
    route: 'Fujairah → Ras Al Khaimah',
    product: 'Fuel Oil 380 CST',
    eta: '16:30 GST',
    delayStatus: 'normal',
    progress: 48,
  },
  {
    id: 'TRP-24020',
    vehicle: 'SHJ-T-4412',
    driver: 'Tariq Al Nuaimi',
    route: 'Jebel Ali → Abu Dhabi ICAD',
    product: 'Methanol',
    eta: '15:55 GST',
    delayStatus: 'delayed',
    progress: 33,
  },
];

export const DELAY_STATUS = {
  normal: {
    label: 'Normal',
    className: 'bg-emerald-50 text-emerald-700 ring-emerald-500/25',
  },
  delayed: {
    label: 'Delayed',
    className: 'bg-red-50 text-red-700 ring-red-500/25',
  },
};

export const ALTERNATIVE_ROUTES = [
  'E611 → E102 (Fujairah Coastal Bypass)',
  'E11 → E88 (Al Dhaid Alternate)',
  'E311 → Sheikh Mohammed Bin Zayed Rd',
  'E102 → Khor Fakkan Mountain Route',
  'Internal Musaffah Service Road',
  'Khalifa Port Express Lane',
];

export const AVAILABLE_DRIVERS = [
  { id: 'DRV-014', name: 'Vikram Singh', status: 'Checked-In · Musaffah' },
  { id: 'DRV-022', name: 'Omar Al Ketbi', status: 'Rest Complete · Jebel Ali' },
  { id: 'DRV-031', name: 'Pradeep Nair', status: 'Checked-In · Fujairah' },
  { id: 'DRV-008', name: 'Hassan Al Zaabi', status: 'On Standby · Ruwais' },
];

export function computeTowerSummary(trips = ACTIVE_TRIPS) {
  const delayed = trips.filter((t) => t.delayStatus === 'delayed').length;
  const avgProgress = Math.round(trips.reduce((s, t) => s + t.progress, 0) / trips.length);
  return {
    activeTrips: trips.length,
    delayed,
    onSchedule: trips.length - delayed,
    avgProgress,
    criticalAlerts: URGENT_ALERTS.filter((a) => a.severity === 'critical').length,
  };
}
